import { render } from "./SvgIcon.vue?vue&type=template&id=4baca347&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=4baca347&scoped=true&lang=scss"

import exportComponent from "../../../sephora/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baca347"]])

export default __exports__